import fetchRedux from "../../api/fetch_redux";
import { toast } from "react-toastify";
import { setAguardar } from "./aguardar-actions";
import { DRAWER } from "../../routes/Curriculo";
import { ToastErro } from "../../utils/utils";

export const CURRICULO_GET_DADOS = "CURRICULO_GET_DADOS"; // Dados gerais dos curriculos
export const CURRICULO_GET_AGENDA_VENCIDA = "CURRICULO_GET_AGENDA_VENCIDA"; // Para curriculos de agenda vencida
export const CURRICULO_FECHAR_AGENDA_VENCIDA =
  "CURRICULO_FECHAR_AGENDA_VENCIDA"; // Para limpar o array da agendaVencida
export const CURRICULO_APROVADO_REPROVADO_RESERVAR_CANDIDATO =
  "CURRICULO_APROVADO_REPROVADO_RESERVAR_CANDIDATO"; // Para aprovar, reprovar ou colocar em lista de espera o candidato
export const CURRICULO_REMOVER_CANDIDATO_AGENDA_VENCIDA =
  "CURRICULO_REMOVER_CANDIDATO_AGENDA_VENCIDA"; // Para remover o candidato da agenda vencida
export const CURRICULO_GET_MINHA_AGENDA = "CURRICULO_GET_MINHA_AGENDA"; // Action para a minha agenda
export const CURRICULO_GET_AGENDA_OUTROS = "CURRICULO_GET_AGENDA_OUTROS"; // Action para a agenda outros
export const CURRICULO_REMOVER_MINHA_AGENDA = "CURRICULO_REMOVER_MINHA_AGENDA"; // Action para remover da agenda
export const CURRICULO_ADD_AGENDA = "CURRICULO_ADD_AGENDA"; // Action para adicionar agenda
export const CURRICULO_UPD_AGENDA = "CURRICULO_UPD_AGENDA"; // Action para editar agenda
export const CURRICULO_GET_DETALHES_CURRICULO =
  "CURRICULO_GET_DETALHES_CURRICULO"; // Action para obter detalhes de um curriculo
export const CURRICULO_GET_DETALHES_CURRICULO_LIMPAR =
  "CURRICULO_GET_DETALHES_CURRICULO_CURRICULO_LIMPAR";
export const CURRICULO_ADD_FAVORITO = "CURRICULO_ADD_FAVORITO"; // Action para adicionar um favorito
export const CURRICULO_DEL_FAVORITO = "CURRICULO_DEL_FAVORITO"; // Action para excluir um favorito
export const CURRICULO_GET_LISTA_MINHA = "CURRICULO_GET_LISTA_MINHA"; // Action para recuperar a minha lista de espera
export const CURRICULO_GET_LISTA_OUTROS = "CURRICULO_GET_LISTA_OUTROS"; // Action para recupera a lista de espera dos outros
export const CURRICULO_LISTA_DE_ESPERA_LIMPAR =
  "CURRICULO_LISTA_DE_ESPERA_LIMPAR"; // Action para limpar a lista de espera
export const CURRICULO_GET_HISTORICO_CURRICULO =
  "CURRICULO_GET_HISTORICO_CURRICULO"; // Action para ver o historico do candidato
export const CURRICULO_FECHAR_HISTORICO_CURRICULO =
  "CURRICULO_FECHAR_HISTORICO_CURRICULO"; // Action para fechar o historico do curriculo
export const CURRICULO_REMOVER_CANDIDATO_LISTA_ESPERA =
  "CURRICULO_REMOVER_CANDIDATO_LISTA_ESPERA"; // Action para remover o candidato da lsita de espera
export const CURRICULO_LIMPAR_MINHA_AGENDA = "CURRICULO_LIMPAR_MINHA_AGENDA"; // Action para limpar a minha agenda
export const CURRICULO_GET_CURRICULO_POR_PAGINA =
  "CURRICULO_GET_CURRICULO_POR_PAGINA"; // Action para obter os curriculos por pagina
export const CURRICULO_FILTRO_AVANCADO_APLICAR =
  "CURRICULO_FILTRO_AVANCADO_APLICAR"; // Action para registrar o filtro avancado aplicado
export const CURRICULO_FILTRO_AVANCADO_LIMPAR =
  "CURRICULO_FILTRO_AVANCADO_LIMPAR"; // Action para limpar o filtro avancado aplicado
export const CURRICULO_SET_DRAWER = "CURRICULO_SET_DRAWER"; // Action para exibir um drawer
export const CURRICULO_FECHAR_DRAWER = "CURRICULO_FECHAR_DRAWER"; // Action para fechar um drawer;

const ROTAS = [
  "/curriculo",
  "/curriculo_agenda",
  "/curriculo_usado",
  "/detalhes_curriculo",
  "/curriculo_favorito",
  "/curriculo_em_espera",
  "/curriculo_historico",
  "/get_curriculo_pagina",
  "/filtro_avancado_curriculo",
];
// Obter os dados iniciais da pagina
export const curriculoGetDados = () => (dispatch) => {
  dispatch(setAguardar(true));
  fetchRedux(
    ROTAS[0],
    "POST",
    null,
    (resp) => {
      // Tudo certo atualiza o objeto principal
      dispatch({
        type: CURRICULO_GET_DADOS,
        data: resp,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Recuperar a agenda do usuario, os que se encontram vencidos
export const curriculoGetAgendaVencida = () => (dispatch) => {
  dispatch(setAguardar(true));
  fetchRedux(
    `${ROTAS[1]}?tipo=agendaVencida`,
    "GET",
    null,
    (resp) => {
      // Tudo certo atualiza o objeto com os itens da agenda vencida
      dispatch({
        type: CURRICULO_GET_AGENDA_VENCIDA,
        data: resp,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Esta funcao vai permitir ao usuario fechar a agenda vencida que foi carregada. Isto só não cobra momentaneamente uma solução
export const curriculoLimparAgendaVencida = () => ({
  type: CURRICULO_FECHAR_AGENDA_VENCIDA,
});
// Esta action vai definir se o usuario vai aprovar ou não o candidato {id_curriculo, observacao, status }
export const curriculoAprovarReprovarReservarCandidato =
  (obj, fn) => (dispatch) => {
    dispatch(setAguardar(true));

    fetchRedux(
      ROTAS[2],
      "POST",
      obj,
      (resp) => {
        //

        toast.dark(resp.sucesso, { type: "success" });
        // Se uma funcao tiver sido enviada ela é para fechar o formulario que foi aberto.
        if (fn) {
          fn();
          // Se estiver vendo detalhes do candidato trate de limpar seus detalhes
          //dispatch( curriculoGetDetalhesCurriculoLimpar() );
        }
        // Tudo certo passa o ID curriculo para retirar o candidato da listagem principal
        dispatch({
          type: CURRICULO_APROVADO_REPROVADO_RESERVAR_CANDIDATO,
          data: { id_curriculo: obj.id_curriculo, status: obj.status },
        });
      },
      () => dispatch(setAguardar(false)),
      (err) => {
        ToastErro(err);
      }
    );
  };
// Esta action vai retirar o candidato a agendaVencida {id_agenda}
export const curriculoRemoverCandidatoAgendaVencida =
  (obj, fn) => (dispatch) => {
    dispatch(setAguardar(true));

    fetchRedux(
      ROTAS[1],
      "DELETE",
      obj,
      (resp) => {
        //

        toast.dark(resp.sucesso, { type: "success" });
        // Se a funcao tiver sido enviada ela e usada para fechar o formulario que se abriu
        if (fn) {
          fn();
          // Se estiver vendo detalhes do candidato trate de limpar seus detalhes
          //dispatch( curriculoGetDetalhesCurriculoLimpar() );
        }

        // Tudo certo passa o id_agenda para removermos o candidato da agendaVencida
        dispatch({
          type: CURRICULO_REMOVER_CANDIDATO_AGENDA_VENCIDA,
          data: obj.id_agenda,
        });
      },
      () => dispatch(setAguardar(false)),
      (err) => {
        ToastErro(err);
      }
    );
  };
// Esta action recupera os curriculos da agenda, seja ela do usuario ou da geral (minhaAgenda|outros)
export const curriculoGetAgenda = (tipoAgenda) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    `${ROTAS[1]}?tipo=${tipoAgenda}`,
    "GET",
    null,
    (resp) => {
      // Tudo certo atualiza o objeto com os itens da agenda
      dispatch({
        type:
          tipoAgenda === "minhaAgenda"
            ? CURRICULO_GET_MINHA_AGENDA
            : CURRICULO_GET_AGENDA_OUTROS,
        data: { dados: resp, tipoAgenda },
      });
      // Setando o drawer para exibir a agenda
      dispatch(
        curriculoSetDrawer({
          tipo: DRAWER.VER_AGENDA,
        })
      );
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Esta action remove candidatos da agenda { id_agenda }
export const curriculoRemoverCandidatoAgenda = (obj) => (dispatch) => {
  dispatch(setAguardar(true));
  fetchRedux(
    ROTAS[1],
    "DELETE",
    obj,
    (resp) => {
      toast.dark(resp.sucesso, { type: "success" });
      // Tudo certo passa o id_agenda e a data para filtrar na agenda atual e remover
      dispatch({
        type: CURRICULO_REMOVER_MINHA_AGENDA,
        data: { id_agenda: obj.id_agenda, data: resp.data },
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Esta action é para editar/criar a agenda para o candidato
export const curriculoAddUpdCandidatoAgenda =
  (obj, editar, fnFecharForm) => (dispatch) => {
    dispatch(setAguardar(true));
    fetchRedux(
      ROTAS[1],
      editar ? "PUT" : "POST",
      obj,
      (resp) => {
        // Tudo certo vamos atualizar o objeto agenda (caso seja put)
        toast.dark(resp.sucesso, { type: "success" });
        // Fechar o drawer (Se editar for false)
        if (!editar) dispatch(curriculoFecharDrawer());
        // Se Editar execute a funcao enviada pois ela determina o fechamento do form para editar o agendamento
        if (editar) fnFecharForm();

        dispatch({
          type: !editar ? CURRICULO_ADD_AGENDA : CURRICULO_UPD_AGENDA,
          data: editar
            ? {
                data: resp.data,
                id_agenda: resp.id_agenda,
                dados: resp.dados,
              }
            : obj.id_curriculo,
        });
      },
      () => dispatch(setAguardar(false)),
      (err) => {
        ToastErro(err);
      }
    );
  };
// Wsta action obtem detalhes de um curriculo (todas as informacoes pessoais)
export const curriculoGetDetalhesCurriculo =
  (id_curriculo, id_agenda, manterDrawerAntigo) => (dispatch) => {
    dispatch(setAguardar(true));
    fetchRedux(
      `${ROTAS[3]}/${id_curriculo}`,
      "GET",
      null,
      (resp) => {
        // Setando para o drawer
        dispatch(
          curriculoSetDrawer(
            {
              tipo: DRAWER.DETALHES_CURRICULO,
              dados: { ...resp, id_curriculo, id_agenda },
            },
            manterDrawerAntigo
          )
        );
      },
      () => dispatch(setAguardar(false)),
      (err) => {
        ToastErro(err);
      }
    );
  };
// Action para adicionar/remover o curriculo do favorito
export const curriculoAddDelFavorito = (obj, deletar) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[4],
    deletar ? "DELETE" : "POST",
    obj,
    (resp) => {
      // // Tudo certo vamos atualizar o objeto agenda (caso seja put)
      dispatch({
        type: !deletar ? CURRICULO_ADD_FAVORITO : CURRICULO_DEL_FAVORITO,
        data: { id_curriculo: obj.id_curriculo, data: resp.corpo },
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Action para recuperar candidatos na lista de espera (minhaLista|outros)
export const curriculoGetListaDeEspera = (tipoLista) => (dispatch) => {
  dispatch(setAguardar(true));
  fetchRedux(
    `${ROTAS[5]}?tipo=${tipoLista}`,
    "GET",
    null,
    (resp) => {
      dispatch(
        curriculoSetDrawer({
          tipo: DRAWER.VER_LISTA_ESPERA,
          dados: { dados: resp, tipoLista },
        })
      );
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Action para fechar (limpar) a lista de espera
export const curriculoLimparListaDeEspera = () => ({
  type: CURRICULO_LISTA_DE_ESPERA_LIMPAR,
});
// Action para fechar a agenda
export const curriculoLimparMinhaAgenda = () => ({
  type: CURRICULO_LIMPAR_MINHA_AGENDA,
});
// Action para recuperar o historico de movimentações do curriculo
export const curriculoGetHistorico =
  (id_curriculo, manterDrawerAntigo) => (dispatch) => {
    dispatch(setAguardar(true));
    fetchRedux(
      `${ROTAS[6]}/${id_curriculo}`,
      "GET",
      null,
      (resp) => {
        // Exibir o historico deste curriculo (movimentacoes)
        dispatch(
          curriculoSetDrawer(
            {
              tipo: DRAWER.VER_HISTORICO_CURRICULO,
              dados: resp,
            },
            manterDrawerAntigo
          )
        );
      },
      () => dispatch(setAguardar(false)),
      (err) => {
        ToastErro(err);
      }
    );
  };
// Action para fechar o historico do curriculo
export const curriculoFecharHistorico = () => ({
  type: CURRICULO_FECHAR_HISTORICO_CURRICULO,
});
// Esta action e para remover o candidato da lista de espera
export const curriculoRemoverCandidatoListaDeEspera = (obj) => (dispatch) => {
  dispatch(setAguardar(true));

  fetchRedux(
    ROTAS[5],
    "DELETE",
    obj,
    (resp) => {
      //
      toast.dark(resp.sucesso, { type: "success" });
      // Tudo certo remove este candidato da lista de espera e limpa o historico caso exista
      dispatch({
        type: CURRICULO_REMOVER_CANDIDATO_LISTA_ESPERA,
        data: obj.id_curriculo,
      });
    },
    () => dispatch(setAguardar(false)),
    (err) => {
      ToastErro(err);
    }
  );
};
// Esta action recebe o numero da pagina e vai obtendo os curriculos por la
export const curriculoGetCurriculoPorPagina = (pagina) => async (dispatch) => {
  fetchRedux(
    `${ROTAS[7]}/${pagina}`,
    "GET",
    null,
    (resp) => {
      // Tudo certo envia para a loja
      dispatch({
        type: CURRICULO_GET_CURRICULO_POR_PAGINA,
        data: resp,
      });
    },
    () => {},
    (err) => {
      ToastErro(err);
    }
  );
};
// Esta action recebe um objeto e o transmite para realizar o filtro dos dados
export const curriculoFiltroAvancadoAplicar =
  (obj, fecharDrawer) => async (dispatch) => {
    const parametros = new URLSearchParams(obj);

    fetchRedux(
      `${ROTAS[8]}?${parametros.toString()}`,
      "GET",
      null,
      (resp) => {
        //
        if (fecharDrawer) fecharDrawer();

        // Tudo certo envia para a loja
        dispatch({
          type: CURRICULO_FILTRO_AVANCADO_APLICAR,
          data: resp,
        });
      },
      () => {},
      (err) => {
        ToastErro(err);
      }
    );
  };
// Esta action limpa o filtro que foi aplicado
export const curriculoFiltroAvancadoLimpar = () => ({
  type: CURRICULO_FILTRO_AVANCADO_LIMPAR,
});
// Criar um drawer
export const curriculoSetDrawer = (obj, keepOld = false) => ({
  type: CURRICULO_SET_DRAWER,
  data: obj,
  keepOld,
});
// Fechar um drawer
export const curriculoFecharDrawer = (obj) => ({
  type: CURRICULO_FECHAR_DRAWER,
});
